import { useState } from "react";

const SUPPORTED_FILE_EXTENSIONS = [".pdf", ".tif", ".tiff", ".las"];

function getFileExtension(fileName) {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex >= 0 ? fileName.slice(dotIndex).toLowerCase() : "";
}

function validateFiles(files) {
  if (!files.length) {
    return "Upload at least one PDF, TIFF or LAS file.";
  }

  const unsupportedFiles = files.filter((file) => {
    const extension = getFileExtension(file.name);
    return !SUPPORTED_FILE_EXTENSIONS.includes(extension);
  });

  if (unsupportedFiles.length) {
    const names = unsupportedFiles.map((file) => file.name).join(", ");
    return `Unsupported file type: ${names}. Upload PDF, TIFF or LAS files only.`;
  }

  return "";
}

export default function ContactForm() {
  const [form, setForm] = useState({ files: [], name: "", email: "", message: "" });
  const [fileInputKey, setFileInputKey] = useState(0);
  const [touched, setTouched] = useState({});
  const [status, setStatus] = useState({ loading: false, ok: null, msg: "" });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const errors = {
    files: validateFiles(form.files),
    name: !form.name.trim() ? "Enter a name" : "",
    email: !form.email.trim() ? "Enter your email address." : !/^\S+@\S+\.\S+$/.test(form.email.trim()) ? "Incorrect email" : ""
  };

  function handleChange(e) {
    const { files, name, value } = e.target;

    if (name === "files") {
      setForm((f) => ({ ...f, files: Array.from(files || []) }));
      setTouched((t) => ({ ...t, files: true }));
      return;
    }

    setForm((f) => ({ ...f, [name]: value }));
  }

  function onBlur(e) {
    if (e.target.name === "files") {
      return;
    }

    setTouched((t) => ({ ...t, [e.target.name]: true }));
  }

  function closeSuccessModal() {
    setShowSuccessModal(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setTouched({ files: true, name: true, email: true, message: true});
    if (errors.files || errors.name || errors.email) return;

    try {
          setStatus({ loading: true, ok: null, msg: "" });

          const payload = new FormData();
          payload.append("name", form.name.trim());
          payload.append("email", form.email.trim());
          payload.append("message", form.message.trim());
          form.files.forEach((file) => {
            payload.append("files[]", file);
          });

          const res = await fetch("/idealwells-api/forms/contact", {
            method: "POST",
            body: payload,
          });

          if (!res.ok) {
            const t = await res.text();
            throw new Error(t || "Server error");
          }

          //setStatus({ loading: false, ok: true, msg: "The request to call the technician has been sent!" });
          setForm({ files: [], name: "", email: "", message: ""});
          setFileInputKey((key) => key + 1);
          setTouched({});
          setStatus({ loading: false, ok: true, msg: "" });
          setShowSuccessModal(true);
         // navigate("/thank-you");

        } catch (err) {
          setStatus({ loading: false, ok: false, msg: "Failed to send. Please try again later." });
        }

  }

  return (
    <section id="contact" className="block block-contact">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-12 text-start header">
            <h2>Data Analysis Request</h2>
            <p className="description">Upload your logs for instant neuralinterpretation.</p>
          </div>
        </div>
     </div>
     <div className="container">
        <div className="row g-4">
          <div className="col-lg-12">
            <form className="border-0 text-start needs-validation form-contact" onSubmit={handleSubmit} noValidate>
              <div className="form-body">
                <div className="row g-3">

               <div className="col-md-12">
                <div className="form-widget-files">
                  <div className="icon-cloud"></div>
                  <input
                    key={fileInputKey}
                    className={`form-control ${touched.files && errors.files ? "is-invalid" : touched.files ? "is-valid" : ""}`}
                    type="file"
                    name="files"
                    accept=".pdf,.tif,.tiff,.las,application/pdf,image/tiff"
                    onChange={handleChange}
                    onBlur={onBlur}
                    required
                    multiple
                  />
                  <label className="form-label">PDF, TIFF, LAS SUPPORTED</label>
                  <div className="invalid-feedback">{errors.files}</div>
                  {form.files.length > 0 && (
                    <ul className="selected-files" aria-label="Selected files">
                      {form.files.map((file, index) => (
                        <li key={`${file.name}-${file.lastModified}-${index}`}>{file.name}</li>
                      ))}
                    </ul>
                  )}
                </div>
               </div>

                  <div className="col-xxl-6">
                    <label className="form-label">YOUR NAME</label>
                    <input
                      className={`form-control ${touched.name && errors.name ? "is-invalid" : touched.name ? "is-valid" : ""}`}
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      onBlur={onBlur}
                      placeholder="Full name"
                      required
                    />
                    <div className="invalid-feedback">{errors.name}</div>
                  </div>

                  <div className="col-xxl-6">
                    <label className="form-label">YOUR EMAIL</label>
                    <input
                      className={`form-control ${touched.email && errors.email ? "is-invalid" : touched.email ? "is-valid" : ""}`}
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      onBlur={onBlur}
                      required
                      placeholder="work@company.com"
                    />
                    <div className="invalid-feedback">{errors.email}</div>
                  </div>

                  <div className="col-md-12 desktop">
                    <label className="form-label">MESSAGE & PARAMETERS</label>
                    <textarea
                      className={`form-control ${touched.message && errors.message ? "is-invalid" : touched.message ? "is-valid" : ""}`}
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      onBlur={onBlur}
                      required
                      placeholder="(Please describe your request: specify the well log type, depth interval to be digitized, and which curves are required. The more details you provide, the more accurate and efficient the digitization will be)"
                      ></textarea>
                    <div className="invalid-feedback">{errors.message}</div>
                  </div>
                </div>

                <button className="btn btn-primary btn-lg mt-3 w-100" disabled={status.loading}>
                      {status.loading ? "Sending..." : "Send request"}
                </button>

                {status.msg && (
                    <div className={`alert mt-3 ${status.ok ? "alert-success" : "alert-danger"}`} role="alert" aria-live="polite">
                        {status.msg}
                    </div>
                )}

              </div>
            </form>
          </div>
        </div>
      </div>
      {showSuccessModal && (
        <div className="success-modal-backdrop">
          <div
            className="success-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="success-modal-title"
          >
            <div className="success-modal__icon" aria-hidden="true">
              <span>&#10003;</span>
            </div>
            <h3 id="success-modal-title">Request Sent!</h3>
            <div className="success-modal__divider"></div>
            <p>
              Please note: processing takes <strong>1-7 days</strong> due to server capacity and high-resolution data validation.
            </p>
            <button className="success-modal__button" type="button" onClick={closeSuccessModal}>
              Return to Site
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
